module.exports = "<a (click)=\"goDashboard()\">\n  <img src=\"/assets/images/menu.svg\" />\n</a>\n"